import { ButtonVariant } from "@acin.reactjs/acin-ui/button";
import { IconButtonsTheme } from "@acin.reactjs/acin-ui/iconButton";
import { applyIconColor, ComponentCSSStyle } from "@acin.reactjs/acin-ui/theme";
import { DefaultTheme } from "styled-components";

const IconButtonTheme = (
  theme: DefaultTheme,
): ComponentCSSStyle<IconButtonsTheme, ButtonVariant> => ({
  root: {
    borderRadius: "4px 20px 20px 16px",
  },

  variants: {
    publicPrimary: {
      root: {
        backgroundColor: theme.palette.secondary[500],

        svg: applyIconColor(theme.palette.common.black),
      },

      hover: {
        root: {
          backgroundColor: theme.palette.secondary[600],
        },
      },
      active: {
        root: {
          backgroundColor: theme.palette.secondary[700],
        },
      },
      focused: {
        root: {
          backgroundColor: theme.palette.secondary[700],
        },
      },
    },
  },
});

export default IconButtonTheme;
